import AppraisalApi from './AppraisalApi';

class Api {
  appraisal = new AppraisalApi();
}

export default Api;
